import React from "react";
import { View, Text } from "@react-pdf/renderer";

const money = (n) => Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function TotalsSection({
  S,
  valorTotal,
  totalNeto,
  totalImpuesto,
  total,
  totalDescuento, 
  shippingTotal
}) {
  return (
    <View style={S.half}>
      <View style={S.totalsBox}>
        <View style={S.totRow}>
          <Text style={S.muted}>Subtotal</Text>
          <Text>{money(valorTotal)}</Text>
        </View>
        <View style={S.totRow}>
          <Text style={S.muted}>Envio</Text>
          <Text>{money(shippingTotal)}</Text>
        </View>

        <View style={S.totRow}>
          <Text style={S.muted}>Descuento</Text>
          <Text>{money(totalDescuento)}</Text>
        </View>

        <View style={S.totRow}>
          <Text style={S.muted}>Total Neto</Text>
          <Text>{money(totalNeto)}</Text>
        </View>

        <View style={S.totRow}>
          <Text style={S.muted}>Total Impuesto</Text>
          <Text>{money(totalImpuesto)}</Text>
        </View>

        <View style={S.totFinal}>
          <Text>Total</Text>
          <Text>{money(total)}</Text>
        </View>
      </View>
    </View>
  );
}